import React from "react";
import * as ROLES from "../constants/roles";
import * as STATES from "../constants/states";
import AcceptTeamInvitation from "./TeamInvitation/acceptTeamInvitation";
import AccountEdit from "./Accounts/accountEdit";
import AccountList from "./Accounts/accountList";
import AccountTreeOutlinedIcon from '@material-ui/icons/AccountTreeOutlined';
import ActivityEdit from "./Activities/activityEdit";
import ActivityList from "./Activities/activityList";
import AlternateEmailOutlinedIcon from "@material-ui/icons/AlternateEmailOutlined";
import BarChartOutlinedIcon from '@material-ui/icons/BarChartOutlined';
import BusinessCenterOutlinedIcon from '@material-ui/icons/BusinessCenterOutlined';
import BusinessIcon from "@material-ui/icons/Business";
import ChatNotes from "./Common/chatNotes";
import CheckBoxOutlinedIcon from "@material-ui/icons/CheckBoxOutlined";
import CloudOutlinedIcon from '@material-ui/icons/CloudOutlined';
import ContactEdit from "./Contacts/contactEdit";
import ContactList from "./Contacts/contactList";
import ContactListContacts from "./ContactLists/contactListContacts";
import ContactListEdit from "./ContactLists/contactListEdit";
import ContactListList from "./ContactLists/contactListList";
import Dashboard from "./Dashboard";
import DeleteForeverOutlinedIcon from '@material-ui/icons/DeleteForeverOutlined';
import DestroyAccount from "./MyAccount/destroyAccount";
import DetailTabs from "./Common/DetailTabs";
import EditTabs from "./Common/EditTabs";
import EmailAddresses from "./Common/emailAddresses";
import EmojiPeopleOutlinedIcon from '@material-ui/icons/EmojiPeopleOutlined';
import EventNoteOutlined from "@material-ui/icons/EventNoteOutlined";
import FaceOutlinedIcon from '@material-ui/icons/FaceOutlined';
import FlashOnOutlinedIcon from '@material-ui/icons/FlashOnOutlined';
import GroupOutlinedIcon from '@material-ui/icons/GroupOutlined';
import IntroductionEdit from "./Introductions/introductionEdit";
import IntroductionList from "./Introductions/introductionList";
import ListOutlinedIcon from '@material-ui/icons/ListOutlined';
import Loading from "./Common/loading";
import MailAddresses from "./Common/mailAddresses";
import MailOutlineOutlinedIcon from "@material-ui/icons/MailOutlineOutlined";
import NoteOutlined from "@material-ui/icons/NoteOutlined";
import ParentShareSelect from "./Common/parentShareSelect";
import ParentShareTabs from "./Common/parentShareTabs";
import PasswordReset from "./PasswordReset/passwordReset";
import ContactAccountPositionsExperienceChart from "./ContactAccountPositions/contactAccountPositionsExperienceChart";
import ContactAccountPositionsExperienceList from "./ContactAccountPositions/contactAccountPositionsExperienceList";
import ContactKeywordCloud from "./ContactKeywords/contactKeywordCloud";
import PersonOutlinedIcon from '@material-ui/icons/PersonOutlined';
import PhoneNumbers from "./Common/phoneNumbers";
import PhoneOutlinedIcon from "@material-ui/icons/PhoneOutlined";
import PopupActivityEdit from "./Popup/popupActivityEdit";
import PopupActivityList from "./Popup/popupActivityList";
import PopupChatNotes from "./Popup/popupChatNotes";
import PopupContactAccountPositionEdit from "./Popup/popupContactAccountPositionEdit";
import PopupContactAccountPositionList from "./Popup/popupContactAccountPositionList";
import PopupContactEdit from "./Popup/popupContactEdit";
import PopupEditTabs from "./Popup/PopupEditTabs";
import PopupEmailAddresses from "./Popup/popupEmailAddresses";
import PopupIntroductionEdit from "./Popup/popupIntroductionEdit";
import PopupIntroductionList from "./Popup/popupIntroductionList";
import PopupMailAddresses from "./Popup/popupMailAddresses";
import PopupPhoneNumbers from "./Popup/popupPhoneNumbers";
import PopupRouter from "./Popup/popupRouter";
import PopupTaskEdit from "./Popup/popupTaskEdit";
import PopupTaskList from "./Popup/popupTaskList";
import Profile from "./MyAccount/profile";
import ProjectEdit from "./Projects/projectEdit";
import ProjectList from "./Projects/projectList";
import RejectTeamInvitation from "./TeamInvitation/rejectTeamInvitation";
import SignIn from "./SignIn/signIn";
import SignUp from "./SignUp/signUp";
import TaskEdit from "./Tasks/taskEdit";
import TaskKanban from "./Tasks/taskKanban";
import TaskList from "./Tasks/taskList";
import TeamEdit from "./Teams/teamEdit";
import TeamList from "./Teams/teamList";
import TeamManagement from "./Common/TeamManagement/teamManagement";
import UserEdit from "./Users/userEdit";
import UserList from "./Users/userList";
import VerifyEmail from "./VerifyEmail/verifyEmail";
import ViewWeekOutlinedIcon from '@material-ui/icons/ViewWeekOutlined';
import VpnKeyOutlinedIcon from '@material-ui/icons/VpnKeyOutlined';
import {ForgotPassword} from "./Common/forgotPassword";
import {useLocation} from "react-router-dom";
import PopupAccountEdit from "./Popup/popupAccountEdit";
import PopupAnalyzeKeywords from "./Popup/popupAnalyzeKeywords";
import PopupUserPreferences from "./Popup/popupUserPreferences";
import WebSockets from "./Common/webSockets";
import PopupContactKeywordCloud from "./Popup/popupContactKeywordCloud";
import PopupContactAccountPositionChart from "./Popup/popupContactAccountPositionChart";

const inIFrame = (window.parent.window !== window);

export const NavRoutes = props => {
    let location = useLocation();

    return {
        root: {
            title: 'JunctionBox.io',
            path: '/',
            redirectMatch: '/',
            redirectSlash: '/dashboard',
            routes: {
                dashboard: {
                    title: 'Dashboard',
                    path: '/dashboard',
                    showInMenu: true,
                    visibleStates: [STATES.LOGGED_IN],
                    visibleRoles: [ROLES.USER_BASIC],
                    visibleTest: !inIFrame,
                    enabledRoles: [ROLES.USER_BASIC],
                    component: <Dashboard/>,
                },
                contacts: {
                    title: 'Contacts',
                    path: '/contacts',
                    showInMenu: true,
                    visibleStates: [STATES.LOGGED_IN],
                    visibleRoles: [ROLES.USER_BASIC],
                    visibleTest: !inIFrame,
                    enabledRoles: [ROLES.USER_BASIC],
                    component: <ContactList/>,
                    routes: {
                        edit: {
                            title: 'Edit',
                            path: '/:editId',
                            component: <EditTabs/>,
                            redirectMatch: '/contacts/:editId',
                            redirectSlash: '/edit/details',
                            routes: {
                                details: {
                                    title: 'Details',
                                    path: '/edit',
                                    icon: <PersonOutlinedIcon/>,
                                    component: <DetailTabs/>,
                                    redirectMatch: '/contacts/:editId/edit',
                                    redirectSlash: '/details',
                                    routes: {
                                        edit: {
                                            title: 'Personal',
                                            path: '/details',
                                            icon: <EmojiPeopleOutlinedIcon/>,
                                            component: <ContactEdit/>
                                        },
                                        email: {
                                            title: 'Email Addresses',
                                            path: '/email',
                                            icon: <AlternateEmailOutlinedIcon/>,
                                            component: <EmailAddresses/>
                                        },
                                        mail: {
                                            title: 'Mail Addresses',
                                            path: '/mail',
                                            icon: <MailOutlineOutlinedIcon/>,
                                            component: <MailAddresses/>
                                        },
                                        phones: {
                                            title: 'Phone Numbers',
                                            path: '/phones',
                                            icon: <PhoneOutlinedIcon/>,
                                            component: <PhoneNumbers/>
                                        }
                                    }
                                },
                                notes: {
                                    title: 'Notes',
                                    path: '/notes',
                                    icon: <NoteOutlined/>,
                                    component: <ParentShareTabs/>,
                                    redirectMatch: '/contacts/:editId/notes',
                                    redirectSlash: '/personal/personal',
                                    routes: {
                                        sharedNotes: {
                                            title: 'Shared Notes',
                                            path: '/:shareCategoryType/:shareCategoryId',
                                            component: <ChatNotes/>
                                        }
                                    }
                                },
                                introductions: {
                                    title: 'Introductions',
                                    path: '/introductions',
                                    icon: <FlashOnOutlinedIcon/>,
                                    component: <IntroductionList/>,
                                    routes: {
                                        edit: {
                                            title: 'Edit',
                                            path: '/:introductionId',
                                            component: <IntroductionEdit/>,
                                        }
                                    }
                                },
                                tasks: {
                                    title: 'Tasks',
                                    path: '/tasks',
                                    icon: <CheckBoxOutlinedIcon/>,
                                    component: <ParentShareTabs/>,
                                    redirectMatch: '/contacts/:editId/tasks',
                                    redirectSlash: '/personal/personal',
                                    routes: {
                                        listOptions: {
                                            title: 'Task List',
                                            path: '/:shareCategoryType/:shareCategoryId/list',
                                            component: <DetailTabs/>,
                                            redirectMatch: '/contacts/:editId/tasks/:shareCategoryType/:shareCategoryId',
                                            redirectSlash: '/checkList',
                                            routes: {
                                                list: {
                                                    title: 'Task List',
                                                    path: '/checkList',
                                                    icon: <ListOutlinedIcon/>,
                                                    component: <TaskList/>,
                                                    routes: {
                                                        edit: {
                                                            title: 'Edit',
                                                            path: '/:editId',
                                                            component: <TaskEdit/>,
                                                        }
                                                    }
                                                },
                                                kanban: {
                                                    title: 'Task Kanban',
                                                    path: '/kanban',
                                                    icon: <ViewWeekOutlinedIcon/>,
                                                    component: <TaskKanban/>,
                                                    routes: {
                                                        edit: {
                                                            title: 'Edit',
                                                            path: '/:editId',
                                                            component: <TaskEdit/>,
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                },
                                activities: {
                                    title: 'Activities',
                                    path: '/activities',
                                    icon: <EventNoteOutlined/>,
                                    component: <ParentShareTabs/>,
                                    redirectMatch: '/contacts/:editId/activities',
                                    redirectSlash: '/personal/personal',
                                    routes: {
                                        list: {
                                            title: 'Activity List',
                                            path: '',
                                            icon: <ListOutlinedIcon/>,
                                            component: <ActivityList/>,
                                            routes: {
                                                edit: {
                                                    title: 'Edit',
                                                    path: '/:editId',
                                                    component: <ActivityEdit/>,
                                                }
                                            }
                                        },
                                    }
                                },
                                personExperience: {
                                    title: 'Experience',
                                    path: '/experience',
                                    icon: <BusinessCenterOutlinedIcon/>,
                                    component: <DetailTabs/>,
                                    redirectMatch: '/contacts/:editId/experience',
                                    redirectSlash: '/list',
                                    routes: {
                                        list: {
                                            title: 'Experience List',
                                            path: '/list',
                                            icon: <ListOutlinedIcon/>,
                                            component: <ContactAccountPositionsExperienceList/>
                                        },
                                        chart: {
                                            title: 'Experience Chart',
                                            path: '/chart',
                                            icon: <BarChartOutlinedIcon/>,
                                            component: <ContactAccountPositionsExperienceChart/>
                                        },
                                    }
                                },
                                personKeywords: {
                                    title: 'Keywords',
                                    path: '/keywords',
                                    icon: <CloudOutlinedIcon/>,
                                    component: <ContactKeywordCloud/>,
                                },
                                list: {
                                    title: 'Contact List',
                                    path: '/contacts',
                                    icon: <ListOutlinedIcon/>,
                                    visibleTest: !inIFrame,
                                }
                            }
                        },
                    }
                },
                accounts: {
                    title: 'Accounts',
                    path: '/accounts',
                    showInMenu: true,
                    visibleStates: [STATES.LOGGED_IN],
                    visibleRoles: [ROLES.USER_BASIC],
                    visibleTest: !inIFrame,
                    enabledRoles: [ROLES.USER_BASIC],
                    component: <AccountList/>,
                    routes: {
                        edit: {
                            title: 'Edit',
                            path: '/:editId',
                            component: <EditTabs/>,
                            redirectMatch: '/accounts/:editId',
                            redirectSlash: '/edit/details',
                            routes: {
                                details: {
                                    title: 'Details',
                                    path: '/edit',
                                    icon: <BusinessIcon/>,
                                    component: <DetailTabs/>,
                                    redirectMatch: '/accounts/:editId/edit',
                                    redirectSlash: '/details',
                                    routes: {
                                        edit: {
                                            title: 'Personal',
                                            path: '/details',
                                            icon: <BusinessIcon/>,
                                            component: <AccountEdit/>
                                        },
                                        email: {
                                            title: 'Email Addresses',
                                            path: '/email',
                                            icon: <AlternateEmailOutlinedIcon/>,
                                            component: <EmailAddresses/>
                                        },
                                        mail: {
                                            title: 'Mail Addresses',
                                            path: '/mail',
                                            icon: <MailOutlineOutlinedIcon/>,
                                            component: <MailAddresses/>
                                        },
                                        phones: {
                                            title: 'Phone Numbers',
                                            path: '/phones',
                                            icon: <PhoneOutlinedIcon/>,
                                            component: <PhoneNumbers/>
                                        }
                                    }
                                },
                                notes: {
                                    title: 'Notes',
                                    path: '/notes',
                                    icon: <NoteOutlined/>,
                                    component: <ParentShareTabs/>,
                                    redirectMatch: '/accounts/:editId/notes',
                                    redirectSlash: '/personal/personal',
                                    routes: {
                                        sharedNotes: {
                                            title: 'Shared Notes',
                                            path: '/:shareCategoryType/:shareCategoryId',
                                            component: <ChatNotes/>
                                        }
                                    }
                                },
                                tasks: {
                                    title: 'Tasks',
                                    path: '/tasks',
                                    icon: <CheckBoxOutlinedIcon/>,
                                    component: <ParentShareTabs/>,
                                    redirectMatch: '/accounts/:editId/tasks',
                                    redirectSlash: '/personal/personal',
                                    routes: {
                                        listOptions: {
                                            title: 'Task List',
                                            path: '/:shareCategoryType/:shareCategoryId/list',
                                            component: <DetailTabs/>,
                                            redirectMatch: '/accounts/:editId/tasks/:shareCategoryType/:shareCategoryId',
                                            redirectSlash: '/checkList',
                                            routes: {
                                                list: {
                                                    title: 'Task List',
                                                    path: '/checkList',
                                                    icon: <ListOutlinedIcon/>,
                                                    component: <TaskList/>,
                                                    routes: {
                                                        edit: {
                                                            title: 'Edit',
                                                            path: '/:editId',
                                                            component: <TaskEdit/>,
                                                        }
                                                    }
                                                },
                                                kanban: {
                                                    title: 'Task Kanban',
                                                    path: '/kanban',
                                                    icon: <ViewWeekOutlinedIcon/>,
                                                    component: <TaskKanban/>,
                                                    routes: {
                                                        edit: {
                                                            title: 'Edit',
                                                            path: '/:editId',
                                                            component: <TaskEdit/>,
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                },
                                activities: {
                                    title: 'Activities',
                                    path: '/activities',
                                    icon: <EventNoteOutlined/>,
                                    component: <ParentShareTabs/>,
                                    redirectMatch: '/accounts/:editId/activities',
                                    redirectSlash: '/personal/personal',
                                    routes: {
                                        list: {
                                            title: 'Activity List',
                                            path: '',
                                            icon: <ListOutlinedIcon/>,
                                            component: <ActivityList/>,
                                            routes: {
                                                edit: {
                                                    title: 'Edit',
                                                    path: '/:editId',
                                                    component: <ActivityEdit/>,
                                                }
                                            }
                                        },
                                    }
                                },
                                list: {
                                    title: 'Account List',
                                    path: '/accounts',
                                    icon: <ListOutlinedIcon/>,
                                }
                            }
                        },
                    }
                },
                tasks: {
                    title: 'Tasks',
                    path: '/tasks',
                    showInMenu: true,
                    visibleStates: [STATES.LOGGED_IN],
                    visibleRoles: [ROLES.USER_BASIC],
                    visibleTest: !inIFrame,
                    enabledRoles: [ROLES.USER_BASIC],
                    component: <ParentShareTabs/>,
                    redirectMatch: '/tasks',
                    redirectSlash: '/personal/personal',
                    routes: {
                        listOptions: {
                            title: 'Task List',
                            path: '/:shareCategoryType/:shareCategoryId',
                            component: <DetailTabs/>,
                            redirectMatch: '/tasks/:shareCategoryType/:shareCategoryId',
                            redirectSlash: '/checkList',
                            routes: {
                                list: {
                                    title: 'Task List',
                                    path: '/checkList',
                                    icon: <ListOutlinedIcon/>,
                                    component: <TaskList/>,
                                    routes: {
                                        edit: {
                                            title: 'Edit',
                                            path: '/:editId',
                                            component: <TaskEdit/>,
                                        }
                                    }
                                },
                                kanban: {
                                    title: 'Task Kanban',
                                    path: '/kanban',
                                    icon: <ViewWeekOutlinedIcon/>,
                                    component: <TaskKanban/>,
                                    routes: {
                                        edit: {
                                            title: 'Edit',
                                            path: '/:editId',
                                            component: <TaskEdit/>,
                                        }
                                    }
                                }
                            }
                        }
                    }
                },
                activities: {
                    title: 'Activities',
                    path: '/activities',
                    showInMenu: true,
                    visibleStates: [STATES.LOGGED_IN],
                    visibleRoles: [ROLES.USER_BASIC],
                    visibleTest: !inIFrame,
                    enabledRoles: [ROLES.USER_BASIC],
                    component: <ParentShareTabs/>,
                    redirectMatch: '/activities',
                    redirectSlash: '/personal/personal',
                    routes: {
                        list: {
                            title: 'Activity List',
                            path: '/:shareCategoryType/:shareCategoryId',
                            icon: <ListOutlinedIcon/>,
                            component: <ActivityList/>,
                            routes: {
                                edit: {
                                    title: 'Edit',
                                    path: '/:editId',
                                    component: <ActivityEdit/>,
                                }
                            }
                        },
                    }
                },
                projects: {
                    title: 'Projects',
                    path: '/projects',
                    showInMenu: true,
                    visibleStates: [STATES.LOGGED_IN],
                    visibleRoles: [ROLES.USER_BASIC],
                    visibleTest: !inIFrame,
                    enabledRoles: [ROLES.USER_BASIC],
                    component: <ParentShareTabs/>,
                    redirectMatch: '/projects',
                    redirectSlash: '/personal/personal',
                    routes: {
                        list: {
                            title: 'Project List',
                            path: '/:shareCategoryType/:shareCategoryId',
                            icon: <ListOutlinedIcon/>,
                            component: <ProjectList/>,
                            routes: {
                                edit: {
                                    title: 'Edit',
                                    path: '/:editId',
                                    component: <EditTabs/>,
                                    redirectMatch: '/projects/:shareCategoryType/:shareCategoryId/:editId',
                                    redirectSlash: '/edit',
                                    routes: {
                                        details: {
                                            title: 'Details',
                                            path: '/edit',
                                            icon: <AccountTreeOutlinedIcon/>,
                                            component: <ProjectEdit/>,
                                        },
                                        notes: {
                                            title: 'Notes',
                                            path: '/notes',
                                            icon: <NoteOutlined/>,
                                            component: <ChatNotes/>,
                                        },
                                        tasks: {
                                            title: 'Tasks',
                                            path: '/tasks',
                                            icon: <CheckBoxOutlinedIcon/>,
                                            component: <DetailTabs/>,
                                            redirectMatch: '/projects/:shareCategoryType/:shareCategoryId/:editId/tasks',
                                            redirectSlash: '/checkList',
                                            routes: {
                                                list: {
                                                    title: 'Task List',
                                                    path: '/checkList',
                                                    icon: <ListOutlinedIcon/>,
                                                    component: <TaskList/>,
                                                    routes: {
                                                        edit: {
                                                            title: 'Edit',
                                                            path: '/:editId',
                                                            component: <TaskEdit/>,
                                                        }
                                                    }
                                                },
                                                kanban: {
                                                    title: 'Task Kanban',
                                                    path: '/kanban',
                                                    icon: <ViewWeekOutlinedIcon/>,
                                                    component: <TaskKanban/>,
                                                    routes: {
                                                        edit: {
                                                            title: 'Edit',
                                                            path: '/:editId',
                                                            component: <TaskEdit/>,
                                                        }
                                                    }
                                                }
                                            }
                                        },
                                        activities: {
                                            title: 'Activities',
                                            path: '/activities',
                                            icon: <EventNoteOutlined/>,
                                            component: <ActivityList/>,
                                            routes: {
                                                edit: {
                                                    title: 'Edit',
                                                    path: '/:editId',
                                                    component: <ActivityEdit/>,
                                                },
                                            }
                                        },
                                    }
                                },
                            }
                        },
                    }
                },
                teams: {
                    title: 'Teams',
                    path: '/teams',
                    showInMenu: true,
                    visibleStates: [STATES.LOGGED_IN],
                    visibleRoles: [ROLES.USER_BASIC],
                    visibleTest: !inIFrame,
                    enabledRoles: [ROLES.USER_PAID, ROLES.ADMIN],
                    component: <TeamList/>,
                    routes: {
                        edit: {
                            title: 'Edit',
                            path: '/:editId',
                            component: <EditTabs/>,
                            redirectMatch: '/teams/:editId',
                            redirectSlash: '/edit',
                            routes: {
                                details: {
                                    title: 'Details',
                                    path: '/edit',
                                    icon: <EmojiPeopleOutlinedIcon/>,
                                    component: <TeamEdit/>
                                },
                                notes: {
                                    title: 'Notes',
                                    path: '/notes',
                                    icon: <NoteOutlined/>,
                                    component: <ParentShareTabs/>,
                                    redirectMatch: '/teams/:editId/notes',
                                    redirectSlash: '/personal/personal',
                                    routes: {
                                        sharedNotes: {
                                            title: 'Shared Notes',
                                            path: '/:shareCategoryType/:shareCategoryId',
                                            component: <ChatNotes/>
                                        }
                                    }
                                },
                                teamMembers: {
                                    title: 'Team Members',
                                    path: '/team-members',
                                    icon: <GroupOutlinedIcon/>,
                                    component: <TeamManagement/>
                                },
                                list: {
                                    title: 'Team List',
                                    path: '/teams',
                                    icon: <ListOutlinedIcon/>,
                                    visibleTest: !inIFrame,
                                }
                            }
                        },
                    }
                },
                contactLists: {
                    title: 'Lists',
                    path: '/contact-lists',
                    showInMenu: true,
                    visibleStates: [STATES.LOGGED_IN],
                    visibleRoles: [ROLES.USER_BASIC],
                    visibleTest: !inIFrame,
                    enabledRoles: [ROLES.USER_BASIC],
                    component: <ParentShareTabs/>,
                    redirectMatch: '/contact-lists',
                    redirectSlash: '/personal/personal',
                    routes: {
                        list: {
                            title: 'List',
                            path: '/:shareCategoryType/:shareCategoryId',
                            icon: <ListOutlinedIcon/>,
                            component: <ContactListList/>,
                            routes: {
                                edit: {
                                    title: 'Edit',
                                    path: '/:editId',
                                    component: <EditTabs/>,
                                    redirectMatch: '/contact-lists/:shareCategoryType/:shareCategoryId/:editId',
                                    redirectSlash: '/edit',
                                    routes: {
                                        details: {
                                            title: 'Details',
                                            path: '/edit',
                                            icon: <ListOutlinedIcon/>,
                                            component: <ContactListEdit/>
                                        },
                                        contactListContacts: {
                                            title: 'Contact List Contacts',
                                            path: '/list',
                                            icon: <GroupOutlinedIcon/>,
                                            component: <ContactListContacts/>
                                        },
                                    }
                                },
                            },
                            routesOld: {
                                edit: {
                                    title: 'Edit',
                                    path: '/:editId',
                                    icon: <ListOutlinedIcon/>,
                                    component: <ContactListEdit/>,
                                },
                            }
                        },
                    }
                },
                users: {
                    title: 'Users',
                    path: '/users',
                    showInMenu: true,
                    visibleStates: [STATES.LOGGED_IN],
                    visibleRoles: [ROLES.ADMIN],
                    visibleTest: !inIFrame,
                    enabledRoles: [ROLES.ADMIN],
                    component: <UserList/>,
                    routes: {
                        edit: {
                            title: 'User',
                            path: '/:editId',
                            icon: <BusinessIcon/>,
                            component: <UserEdit/>
                        },
                    },
                },
                verifyEmailSent: {
                    title: 'Verify Email Sent',
                    path: '/verify-email/:userVerificationId',
                    showInMenu: false,
                    visibleStates: [STATES.LOGGED_IN_UNVERIFIED],
                    component: <VerifyEmail/>,
                },
                verifyEmail: {
                    title: 'Verify Email',
                    path: '/verify-email',
                    showInMenu: false,
                    visibleStates: [STATES.LOGGED_IN_UNVERIFIED],
                    component: <VerifyEmail/>,
                },
                acceptTeamInvitation: {
                    title: 'Accept Team Invitation',
                    path: '/accept-team-invitation/:teamInvitationId',
                    showInMenu: false,
                    visibleStates: [STATES.LOGGED_OUT, STATES.LOGGED_IN, STATES.LOGGED_IN_UNVERIFIED],
                    component: <AcceptTeamInvitation/>,
                },
                rejectTeamInvitation: {
                    title: 'Reject Team Invitation',
                    path: '/reject-team-invitation/:teamInvitationId',
                    showInMenu: false,
                    visibleStates: [STATES.LOGGED_OUT, STATES.LOGGED_IN, STATES.LOGGED_IN_UNVERIFIED],
                    component: <RejectTeamInvitation/>,
                },
                settings: {
                    title: 'Settings',
                    path: '/settings',
                    component: <DetailTabs/>,
                    redirectMatch: '/settings',
                    redirectSlash: '/settings/profile',
                    routes: {
                        profile: {
                            title: 'My Profile',
                            path: '/profile',
                            icon: <FaceOutlinedIcon/>,
                            component: <Profile/>,
                        },
                        resetPassword: {
                            title: 'Reset Password',
                            path: '/password-reset',
                            icon: <VpnKeyOutlinedIcon/>,
                            component: <PasswordReset/>,
                        },
                        destroyAccount: {
                            title: 'Destroy Account',
                            path: '/destroy-account',
                            icon: <DeleteForeverOutlinedIcon/>,
                            component: <DestroyAccount/>,
                        },
                    }
                },
                signIn: {
                    title: 'Sign In',
                    path: '/sign-in',
                    showInMenu: true,
                    visibleStates: [STATES.LOGGED_OUT],
                    visibleTest: location && location.pathname !== '/sign-in',
                    component: <SignIn/>,
                },
                signUp: {
                    title: 'Sign Up',
                    path: '/sign-up',
                    showInMenu: true,
                    visibleStates: [STATES.LOGGED_OUT],
                    visibleTest: location && location.pathname !== '/sign-up',
                    component: <SignUp/>,
                },
                loading: {
                    title: 'Loading',
                    path: '/loading',
                    showInMenu: false,
                    component: <Loading/>,
                },
                forgotPassword: {
                    title: 'Forgot Password',
                    path: '/forgot-password',
                    component: <ForgotPassword/>,
                },
                popup: {
                    title: 'Popup',
                    path: '/popup',
                    showInMenu: false,
                    visibleStates: [STATES.LOGGED_IN],
                    visibleRoles: [ROLES.USER_BASIC],
                    component: <PopupRouter/>,
                    routes: {
                        editContact: {
                            title: 'Edit Contact',
                            path: '/contact/:editId',
                            params: {
                                editType: 'contact',
                            },
                            component: <PopupEditTabs/>,
                            redirectMatch: '/popup/contact/:editId',
                            redirectSlash: '/edit',
                            routes: {
                                edit: {
                                    title: 'Personal',
                                    path: '/edit',
                                    icon: <PersonOutlinedIcon/>,
                                    component: <PopupContactEdit/>,
                                },
                                positions: {
                                    title: 'Positions',
                                    path: '/positions',
                                    icon: <BusinessCenterOutlinedIcon/>,
                                    component: <PopupContactAccountPositionList/>,
                                    routes: {
                                        edit: {
                                            title: 'Edit',
                                            path: '/:accountId/:contactAccountPositionId',
                                            component: <PopupContactAccountPositionEdit/>,
                                        }
                                    }
                                },
                                positionChart: {
                                    title: 'Position Chart',
                                    path: '/positionChart',
                                    icon: <BarChartOutlinedIcon/>,
                                    component: <PopupContactAccountPositionChart/>,
                                },
                                keywords: {
                                    title: 'Keywords',
                                    path: '/keywords',
                                    icon: <CloudOutlinedIcon/>,
                                    component: <PopupContactKeywordCloud/>,
                                },
                                email: {
                                    title: 'Email Addresses',
                                    path: '/email',
                                    icon: <AlternateEmailOutlinedIcon/>,
                                    component: <PopupEmailAddresses/>
                                },
                                mail: {
                                    title: 'Mail Addresses',
                                    path: '/mail',
                                    icon: <MailOutlineOutlinedIcon/>,
                                    component: <PopupMailAddresses/>
                                },
                                phones: {
                                    title: 'Phone Numbers',
                                    path: '/phones',
                                    icon: <PhoneOutlinedIcon/>,
                                    component: <PopupPhoneNumbers/>
                                },
                                notes: {
                                    title: 'Notes',
                                    path: '/notes',
                                    icon: <NoteOutlined/>,
                                    component: <ParentShareSelect/>,
                                    redirectMatch: '/popup/contact/:editId/notes',
                                    redirectSlash: '/personal/personal',
                                    routes: {
                                        sharedNotes: {
                                            title: 'Notes',
                                            path: '/:shareCategoryType/:shareCategoryId',
                                            component: <PopupChatNotes/>
                                        }
                                    }
                                },
                                introductions: {
                                    title: 'Introductions',
                                    path: '/introductions',
                                    icon: <FlashOnOutlinedIcon/>,
                                    component: <PopupIntroductionList/>,
                                    routes: {
                                        edit: {
                                            title: 'Edit',
                                            path: '/:introductionId',
                                            component: <PopupIntroductionEdit/>,
                                        }
                                    }
                                },
                                tasks: {
                                    title: 'Tasks',
                                    path: '/tasks',
                                    icon: <CheckBoxOutlinedIcon/>,
                                    component: <ParentShareSelect/>,
                                    redirectMatch: '/popup/contact/:editId/tasks',
                                    redirectSlash: '/personal/personal',
                                    routes: {
                                        list: {
                                            title: 'Tasks',
                                            path: '',
                                            icon: <ListOutlinedIcon/>,
                                            component: <PopupTaskList/>,
                                            routes: {
                                                edit: {
                                                    title: 'Edit',
                                                    path: '/:editId',
                                                    component: <PopupTaskEdit/>,
                                                }
                                            }
                                        },
                                    }
                                },
                                activities: {
                                    title: 'Activities',
                                    path: '/activities',
                                    icon: <EventNoteOutlined/>,
                                    component: <ParentShareSelect/>,
                                    redirectMatch: '/popup/contact/:editId/activities',
                                    redirectSlash: '/personal/personal',
                                    routes: {
                                        list: {
                                            title: 'Activity List',
                                            path: '',
                                            icon: <ListOutlinedIcon/>,
                                            component: <PopupActivityList/>,
                                            routes: {
                                                edit: {
                                                    title: 'Edit',
                                                    path: '/:editId',
                                                    component: <PopupActivityEdit/>,
                                                }
                                            }
                                        },
                                    }
                                },
                            }
                        },
                        editAccount: {
                            title: 'Edit Account',
                            path: '/account/:editId',
                            params: {
                                editType: 'account',
                            },
                            component: <PopupEditTabs/>,
                            redirectMatch: '/popup/account/:editId',
                            redirectSlash: '/edit',
                            routes: {
                                edit: {
                                    title: 'Personal',
                                    path: '/edit',
                                    icon: <BusinessIcon/>,
                                    component: <PopupAccountEdit/>,
                                },
                                email: {
                                    title: 'Email Addresses',
                                    path: '/email',
                                    icon: <AlternateEmailOutlinedIcon/>,
                                    component: <PopupEmailAddresses/>
                                },
                                mail: {
                                    title: 'Mail Addresses',
                                    path: '/mail',
                                    icon: <MailOutlineOutlinedIcon/>,
                                    component: <PopupMailAddresses/>
                                },
                                phones: {
                                    title: 'Phone Numbers',
                                    path: '/phones',
                                    icon: <PhoneOutlinedIcon/>,
                                    component: <PopupPhoneNumbers/>
                                },
                                notes: {
                                    title: 'Notes',
                                    path: '/notes',
                                    icon: <NoteOutlined/>,
                                    component: <ParentShareSelect/>,
                                    redirectMatch: '/popup/account/:editId/notes',
                                    redirectSlash: '/personal/personal',
                                    routes: {
                                        sharedNotes: {
                                            title: 'Notes',
                                            path: '/:shareCategoryType/:shareCategoryId',
                                            component: <PopupChatNotes/>
                                        }
                                    }
                                },
                                tasks: {
                                    title: 'Tasks',
                                    path: '/tasks',
                                    icon: <CheckBoxOutlinedIcon/>,
                                    component: <ParentShareSelect/>,
                                    redirectMatch: '/popup/account/:editId/tasks',
                                    redirectSlash: '/personal/personal',
                                    routes: {
                                        list: {
                                            title: 'Tasks',
                                            path: '',
                                            icon: <ListOutlinedIcon/>,
                                            component: <PopupTaskList/>,
                                            routes: {
                                                edit: {
                                                    title: 'Edit',
                                                    path: '/:editId',
                                                    component: <PopupTaskEdit/>,
                                                }
                                            }
                                        },
                                    }
                                },
                                activities: {
                                    title: 'Activities',
                                    path: '/activities',
                                    icon: <EventNoteOutlined/>,
                                    component: <ParentShareSelect/>,
                                    redirectMatch: '/popup/account/:editId/activities',
                                    redirectSlash: '/personal/personal',
                                    routes: {
                                        list: {
                                            title: 'Activity List',
                                            path: '',
                                            icon: <ListOutlinedIcon/>,
                                            component: <PopupActivityList/>,
                                            routes: {
                                                edit: {
                                                    title: 'Edit',
                                                    path: '/:editId',
                                                    component: <PopupActivityEdit/>,
                                                }
                                            }
                                        },
                                    }
                                },
                            }
                        },
                        analyzeKeywords: {
                            title: 'Analyze Keywords',
                            path: '/analyze-keywords',
                            component: <PopupAnalyzeKeywords/>,
                        },
                        signIn: {
                            title: 'Sign In',
                            path: '/sign-in',
                            component: <SignIn/>,
                        },
                        userPreferences: {
                            title: 'User Preferences',
                            path: '/user-preferences',
                            component: <PopupUserPreferences/>,
                        }
                    }
                },
                ws: {
                    title: 'Websockets',
                    path: '/ws',
                    showInMenu: false,
                    component: <WebSockets/>,
                },
            },
        }
    };
};
